var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Event as EventModel } from '@/models/Event';
import { formatDate as format } from '@/support/String';
let AddEventDialog = class AddEventDialog extends Vue {
    constructor() {
        super(...arguments);
        this.newEvent = null;
        this.isEditingStartDate = false;
        this.isEditingEndDate = false;
        this.recurringEvent = false;
        this.selectedRecurringEvent = null;
    }
    get recurringEvents() {
        return [
            {
                title: this.$t('event.dialog.daily').toString(),
                key: 'daily',
            },
            {
                title: this.$t('event.dialog.weekly').toString(),
                key: 'weekly',
            },
            {
                title: this.$t('event.dialog.monthly').toString(),
                key: 'monthly',
            },
        ];
    }
    mounted() { }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    createOrUpdate() {
        if (!this.newEvent) {
            return;
        }
        if (this.newEvent.id) {
            this.update();
        }
        else {
            this.create();
        }
    }
    create() {
        if (!this.newEvent) {
            return;
        }
        if (this.recurringEvent) {
            this.newEvent.recurring = this.createRecurrencePayload();
        }
        this.newEvent
            .create()
            .then((event) => {
            this.$emit('eventCreated', event);
            this.$emit('input', false);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        this.clear();
    }
    clear() {
        this.newEvent = new EventModel();
        this.recurringEvent = false;
    }
    createRecurrencePayload() {
        if (!this.selectedRecurringEvent) {
            return;
        }
        const payload = {
            repeat_year: '*',
            repeat_month: '*',
            repeat_week: '*',
        };
        if (this.selectedRecurringEvent.key === 'daily') {
            payload.repeat_day = '*';
            payload.repeat_weekday = '*';
        }
        else if (this.selectedRecurringEvent.key === 'weekly') {
            payload.repeat_day = '*';
            payload.repeat_weekday = format(this.event.starts_at || '', 'c');
        }
        else if (this.selectedRecurringEvent.key === 'monthly') {
            payload.repeat_day = format(this.event.starts_at || '', 'L');
            payload.repeat_weekday = '*';
        }
        return payload;
    }
    update() {
        if (!this.newEvent) {
            return;
        }
        this.newEvent
            .update()
            .then((event) => {
            this.$emit('eventUpdated', event);
            this.$emit('input', false);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        this.clear();
    }
    remove() {
        if (!this.newEvent) {
            return;
        }
        const eventId = this.newEvent.id;
        this.newEvent
            .delete()
            .then(() => {
            this.$emit('eventRemoved', eventId);
            this.$emit('input', false);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    parseEvent(event) {
        const parsed = {
            id: event.id,
            title: event.title,
            start: event.starts_at,
            ends: event.ends_at,
            editable: true,
            className: `${event.type}__events`,
        };
        return parsed;
    }
    eventChanged(event) {
        if (event) {
            this.newEvent = event.clone();
            if (this.userId) {
                this.newEvent.users = [{ id: this.userId }];
            }
        }
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof EventModel !== "undefined" && EventModel) === "function" ? _a : Object)
], AddEventDialog.prototype, "event", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", String)
], AddEventDialog.prototype, "userId", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], AddEventDialog.prototype, "editable", void 0);
__decorate([
    Watch('event'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof EventModel !== "undefined" && EventModel) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], AddEventDialog.prototype, "eventChanged", null);
AddEventDialog = __decorate([
    Component({
        components: {
            SelectFilter,
        },
        filters: {
            formatDate(date) {
                return !date ? '' : format(date, 'dd-LL-yyyy');
            },
            formatTime(time) {
                return !time ? '' : format(time, 'HH:mm');
            },
        },
    })
], AddEventDialog);
export default AddEventDialog;
